module.exports = __webpack_public_path__ + "img/download-tp-prod.1b3105d8.png";